import { ErrorMessageKeys } from '../models/errors.models';
import {
  ERROR_KEY_NAME_CONVENTION,
  ERROR_KEYS,
  ERROR_MESSAGE_NAME_CONVENTION,
  ERROR_MESSAGES,
} from './error-messages.constants';

/**
 * Filters `ERROR_MESSAGES` to include only keys that start with `ERROR_MESSAGE_NAME_CONVENTION`.
 * Constructs a strictly typed record containing these filtered entries.
 *
 * @returns A record where each key conforms to the naming convention and maps to its corresponding value in `ERROR_MESSAGES`.
 */
export const MESSAGES: Record<ErrorMessageKeys, string> = Object.entries(
  ERROR_MESSAGES,
)
  .filter(([key]) => key.startsWith(ERROR_MESSAGE_NAME_CONVENTION)) // Retain only keys matching the naming convention
  .reduce(
    (acc, [key, value]) => {
      acc[key as ErrorMessageKeys] = value; // Strictly type each key for assignment
      return acc;
    },
    {} as Record<ErrorMessageKeys, string>, // Initialize an empty strongly typed record
  );

/**
 * Maps `ERROR_KEYS` to their corresponding messages in `MESSAGES`.
 * Dynamically transforms keys by replacing `ERROR_KEY_NAME_CONVENTION` with `ERROR_MESSAGE_NAME_CONVENTION`.
 *
 * @returns A record where each key from `ERROR_KEYS` is mapped to its corresponding message in `MESSAGES`.
 */
export const APP_ERRORS: Record<string, string> = Object.entries(
  ERROR_KEYS,
).reduce(
  (acc, [key, keyValue]) => {
    const messageKey = key.replace(
      ERROR_KEY_NAME_CONVENTION,
      ERROR_MESSAGE_NAME_CONVENTION,
    ) as ErrorMessageKeys; // Dynamically derive the message key

    if (MESSAGES[messageKey]) {
      acc[keyValue] = MESSAGES[messageKey]; // Assign the key-value pair if the message exists
    }
    return acc;
  },
  {} as Record<string, string>, // Initialize an empty record for `APP_ERRORS`
);
